// extracted by mini-css-extract-plugin
module.exports = {"instaHeader":"InstagramProductSlider_instaHeader__2GO6D"};